import React from 'react'
import { Link } from "gatsby"
import * as style from "./about.module.css"
import Layout from "../components/layout"
import SEO from "../components/seo" 

const About = () => (
    <Layout>
        <SEO title="About" />
        <div className={style.container}>
            <h1>About Untools</h1>
            <p>
                Untools is a curated collection of thinking tools. These frameworks are designed to help you make better decisions, solve problems, and see situations more clearly.
            </p>
            <p>
                The tools here are drawn from psychology, systems thinking, decision science, and strategy. Some are well known. Others are less familiar. All are selected for one reason. They are useful.
            </p>
            <p>
                Untools is not about productivity hacks or quick wins. It is about building a deeper and more reliable way to think. One that holds up under complexity, uncertainty, and real world constraints.
            </p>
            <p>
                Each tool is presented simply so you can understand it quickly and apply it immediately. Over time, these tools become part of how you approach decisions, not just something you reference.
            </p>
            <p>
                For those who want to go further, the <Link to="/templates/">Untools Vault</Link> expands on these frameworks with practical templates and resources designed to support real use.
            </p>
        </div>
    </Layout>
)

export default About